import { faLeaf, faEdit } from '@fortawesome/free-solid-svg-icons';
import { faReact, faJsSquare, faNodeJs } from '@fortawesome/free-brands-svg-icons';
import * as S from './style';
import ServiceItem from '../ServiceItem';

const ServicesList = () => {
  return (
    <S.ServiceList>
      <S.ServiceColumn className="col">
        <ServiceItem
          icon={faLeaf}
          title="Web Design"
          description="process of planning and executing the design of a website or a web application"
        />
        <ServiceItem
          icon={faJsSquare}
          title="JavaScript"
          description="JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions. It is a part of the client-side web "
        />
        <ServiceItem
          icon={faEdit}
          title="HTML"
          description="HTML is the standard markup language for creating Web pages."
        />
      </S.ServiceColumn>
      <S.ServiceColumnMid>
        <ServiceItem
          className="col-mid"
          title="What I Do"
          description="I am a full-stack developer with a passion for building web applications. I have a background in web development and have worked with a wide variety of technologies."
        />
      </S.ServiceColumnMid>
      <S.ServiceColumn>
        <ServiceItem
          icon={faReact}
          title="React"
          description="React is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies. "
        />
        <ServiceItem
          icon={faNodeJs}
          title="NodeJs"
          description="Node.js is an open-source, cross-platform JavaScript run-time environment that executes JavaScript code outside of a browser. "
        />
        <ServiceItem
          title="PostgreSQL"
          description="PostgreSQL is a powerful, open source object-relational database system. "
        />
      </S.ServiceColumn>
    </S.ServiceList>
  );
};
export default ServicesList;
